import React, { createContext, useContext, useRef } from 'react'
import { mergeClasses } from '@/helpers/styling'
import uniqueId from 'lodash.uniqueid'

export function Form(props: React.FormHTMLAttributes<HTMLFormElement>) {
  return (
    <form {...props}
          onSubmit={props.onSubmit ?? (e => e.preventDefault())}
          className={mergeClasses(
            "flex flex-col gap-3 p-2 text-xs font-inter",
            props.className)}>
      {props.children}
    </form>
  )
}

export const FormFieldIdContext = createContext<string | undefined>(undefined)
export const useFormFieldId = () => useContext(FormFieldIdContext)

export function FormField(props: {
  inputId?: string
  children: (React.ReactNode | ((id: string) => React.ReactNode))
} & Omit<React.HTMLAttributes<HTMLDivElement>, "children">) {
  const generatedId = useRef(uniqueId("form-field-"))
  const id = props.inputId || generatedId.current
  return (
    <div {...props} className={mergeClasses(
      "flex flex-col gap-1.5", props.className)}>
      <FormFieldIdContext.Provider value={id}>
        {typeof props.children === "function"
          ? props.children(id)
          : props.children
        }
      </FormFieldIdContext.Provider>
    </div>
  )
}

export function Label(props: React.LabelHTMLAttributes<HTMLLabelElement>) {
  const defaultFor = useFormFieldId()
  return (
    <label htmlFor={defaultFor} {...props} className={mergeClasses(`
        flex gap-1 w-full m-0
        whitespace-pre-line font-medium
        text-xs text-muted-foreground
      `, props.className)}>
      {props.children}
    </label>
  )
}

export function CheckboxLabel(props: React.LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label className="flex items-center gap-1.5 m-0 text-[13px] text-foreground/80 select-none" {...props}>
      {props.children}
    </label>
  )
}
